import { jwtDecode } from 'jwt-decode'

export enum UserRole {
  user = 'user',
  anonymous = 'anonymous'
}

// TODO: move playerInfo to contract to avoid doing extra request for player info. see lib/src/auth.ts
interface PlayerInfo {
  role: UserRole
}

interface JwtPayload {
  playerId: string
  name: string
  playerInfo?: PlayerInfo
  // Standard JWT fields
  iat?: number
  exp?: number
  iss?: string
  aud?: string
}

export function decodeJwtPlayerInfo(token: string): PlayerInfo | null {
  try {
    const decoded = jwtDecode<JwtPayload>(token)

    return decoded.playerInfo || { role: UserRole.anonymous }
  } catch (error) {
    console.warn('Failed to decode JWT token:', error)
    return null
  }
}

export function isJwtExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<JwtPayload>(token)

    if (!decoded.exp) {
      return false // No expiration means token doesn't expire
    }

    const currentTime = Date.now() / 1000
    return decoded.exp < currentTime
  } catch (error) {
    return true // If we can't decode it, consider it expired
  }
}
